module.exports = __webpack_public_path__ + "static/img/menuMobile.939ee3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/menuMobile.png
// module id = mOrx
// module chunks = 0